import React, { useEffect } from 'react';
import { useContainerQuery } from '../../internal/hooks/container-queries';
function getScrollableContainers(element) {
    var node = element;
    while ((node = node.parentElement) && node !== document.body) {
        if (['scroll', 'auto'].indexOf(getComputedStyle(node).overflow) > -1) {
            return node;
        }
    }
    return null;
}
export function useStickyPosition(topOffset) {
    if (topOffset === void 0) { topOffset = 0; }
    var _a = useContainerQuery(function (rect) { return rect.height; }), stickyHeight = _a[0], stickyRef = _a[1];
    var _b = useContainerQuery(function (rect) { return rect.width; }), stickyWidth = _b[0], placeholderRef = _b[1];
    var placeholder = React.createElement("div", { ref: placeholderRef });
    useEffect(function () {
        if (!stickyRef.current || !placeholderRef.current) {
            return;
        }
        var stickyElement = stickyRef.current;
        var placeholder = placeholderRef.current;
        var scrollParent = getScrollableContainers(stickyElement);
        var handler = function () {
            var stickyBox = stickyElement.getBoundingClientRect();
            var containerBox = scrollParent ? scrollParent.getBoundingClientRect() : { top: 0 };
            if (stickyBox.top - containerBox.top <= topOffset) {
                stickyElement.style.position = 'fixed';
                stickyElement.style.width = stickyWidth + "px";
                stickyElement.style.top = topOffset + "px";
                placeholder.style.height = stickyHeight + "px";
            }
            else {
                stickyElement.style.position = '';
                stickyElement.style.width = "";
                stickyElement.style.top = "";
                placeholder.style.height = "";
            }
        };
        var eventTarget = scrollParent || window;
        eventTarget.addEventListener('scroll', handler);
        handler();
        return function () { return eventTarget.removeEventListener('scroll', handler); };
    }, [topOffset, stickyWidth, stickyHeight, stickyRef, placeholderRef]);
    return [stickyRef, placeholder];
}
//# sourceMappingURL=use-sticky-position.js.map